module.exports = __webpack_public_path__ + "img/114.2a3af8d8.jpg";